import cityScreen from '@/components/cityScreen.vue'; //省市区筛选统一展示
import notionScreen from '@/components/notionScreen.vue'; //企业列表概念notion筛选统一展示
import ad from '@/components/ad.vue'; //广告组件


export default (Vue) => {
Vue.component('cityScreen', cityScreen);
Vue.component('notionScreen', notionScreen);
Vue.component('ad', ad);
}



